import React, {useState, useEffect} from 'react';
import '../css/App.css';
import '../css/bootstrap.min.css';
import refreshIcon from '../img/refresh.png';
import settingsIcon from '../img/settings.png';
import bootstrap from 'bootstrap';
import NotificationRow from './NotificationRow';
import NotificationCreator from './NotificationCreator';
import Time from '../Time';
import Notify from '../Notify';
import NotificationSettings from './NotificationSettings';
import AllNotifications from './AllNotifications';

class NotificationsBoard extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      user: this.props.user,
      notifications:[],
      showCreator:false,
      showSettings:false,
      showNotificationViewer: false,
      notificationInterval: setInterval(
        () => { 
          this.callNotificatons(); 
          this.notifyNewNotifications();
        }, 60*1000),
      refreshTime:0.1
    };
   this.callNotificatons = this.callNotificatons.bind(this);
   this.AddNotificationBtn = this.AddNotificationBtn.bind(this);
   this.removeNotification = this.removeNotification.bind(this);
   this.openCloseSettings = this.openCloseSettings.bind(this);
   this.refreshNotifications = this.refreshNotifications.bind(this);
  }

  //Everytime you type something on the form it updates the state of this component
  handleFormChange = (e) =>{
    this.setState({[e.target.id]: e.target.value});
  }

  //This method gets the notifications from the database
  callNotificatons = async () => {

    const timeDate = Time.getComputerTimeDate();
    let user = this.props.user;
    
    let fetchRequest = await fetch("https://dashboard.realsexdoll.info/php/notifications/notifications.php?name="+user+"&dateTime="+timeDate);
    const result = await fetchRequest.json();
    //console.log(result);
    this.setState({notifications:result});

  }

  //this checks only for notifications that the user did not see yet
  //then notify only these
  notifyNewNotifications = async()=>{

    const timeDate = Time.getComputerTimeDate();
    let user = this.props.user;

    //Check if there are new notifications and alert the user
    let formdata = new FormData();
    formdata.append("name", user);
    formdata.append("dateTime", timeDate);

    const requestOptions = {
      method: 'POST',
      body: formdata,
      redirect: 'follow'
    };

    let fetchNewNotification = await fetch("https://dashboard.realsexdoll.info/php/notifications/markseen.php", requestOptions);
    const resultNewNotification = await fetchNewNotification.json();

    //Notify user in some cases
    if(resultNewNotification.length > 1){
      Notify.alertText("You have "+resultNewNotification.length+" new notifications")
    }else if(resultNewNotification.length == 1){
      Notify.alertText(resultNewNotification[0].NotificationText)
    }

  }
  
  //Shows or hide the Notification Creator
  AddNotificationBtn = () => {
    let addNotificationStatus = this.state.showCreator;
    this.setState({showCreator:!addNotificationStatus})
    this.refreshNotifications();
  }
  
  //Shows or hide the Notifications Viewer
  openCloseNotifications = () => {
    let windowStatus = this.state.showNotificationViewer;
    this.setState({showNotificationViewer:!windowStatus})
  }
  //Opens or closes the Notification Settings
  openCloseSettings = () =>{
    let showSettingsWindow = this.state.showSettings;
    this.setState({showSettings:!showSettingsWindow})
  } 
  
  //Reload all notifications and check if there are new ones to be shown
  refreshNotifications(){
    this.callNotificatons();
    this.notifyNewNotifications();
  }
  //hides the notification from the notification list
  removeNotification = (i) => {
    //gets the notification Array
    let notificationArray = this.state.notifications;
    //Removes the selected notification from the array
    notificationArray.splice(i,1);
    this.setState({notifications:notificationArray})
  }
  
  //This runs when the dashboard opens
  componentDidMount(){

    //Refresh notifications every Interval selected by the user
    this.refreshNotifications();

  }

  render(){

    //Render each Notification from the notifications state
    let notificationList;
    if(this.state.notifications.length > 0){
      notificationList = this.state.notifications.map((notification, index) =>
        <NotificationRow

          key={index.toString()}
          i={index}
          deleteNotification={this.removeNotification}
          user={this.state.user}
          link={notification.CompletionRequirementReferenceValue}
          text={notification.NotificationText}
          generatedBy={notification.GeneratedBy}
          snoozeCount={notification.snoozeCount}
          seenDate={notification.seenDateTime}
          priority={notification.Priority}
          date={notification.generatedDate}
          id={notification.notificationId}
          userNotificationId={notification.id}
          refreshAll={this.refreshNotifications}
          
        />

      )
    }else{
      
    }
    
    //This counts each notification type
    let countLowPriority = 0
    let countMedPriority = 0
    let countHighPriority = 0
    for(let notification of this.state.notifications){
      if(notification.Priority < 5){countLowPriority++;}
      else if(notification.Priority > 4 && notification.Priority < 8){countMedPriority++;}
      else{countHighPriority++;}
    }
    
    //Renders the Notification Creator if user clicks the create notification button
    let notificationCreator;
    if(this.state.showCreator){
      notificationCreator = 
      <NotificationCreator 
        close={this.AddNotificationBtn}
        user={this.state.user} 
      />
    }
    let notificationsViewer;
    if(this.state.showNotificationViewer){
      notificationsViewer = 
      <AllNotifications 
        close={this.openCloseNotifications}
        user={this.state.user} 
      />
    }

    let notificationSettings;
    if(this.state.showSettings){
      notificationSettings = <NotificationSettings 
        close={this.openCloseSettings}
      />
    }

    return(   
          <div className="board">
            {notificationCreator}
            {notificationSettings}
            {notificationsViewer}
            <header>
              <div className="row">
                <div className='col-8'>
                  <h2>Notifications</h2>
                </div>
                <div className='row col-4'>
                  <div className='col-4'>
                    <h5 className='text-end'>High: {countHighPriority}</h5>
                  </div>
                  <div className='col-4'>
                    <h5 className='text-end'>Med: {countMedPriority}</h5>
                  </div>
                  <div className='col-4'>
                    <h5 className='text-end'>Low: {countLowPriority}</h5>
                  </div>
                </div>
              </div>
            </header>
            <div className='wrapper'>
              <div className="notification-board container-fluid">
              <table className="table table-hover">
                <thead>
                  <tr>
                    <th className='col-1'>Priority</th>
                    <th>Notification</th>
                    <th>Date</th>
                    <th>Actions</th>
                  </tr>
                </thead>
                <tbody>
                  {notificationList}
                </tbody>
              </table>
              </div>
            </div>
            <footer>
              <div className="row">
                <div className='col-6'>
                  <div className="d-grid gap-2 d-md-flex justify-content-md-start">
                    <button className="" onClick={this.openCloseSettings} type="button">
                      <img className='button-icon' src={settingsIcon}></img>
                    </button>
                  </div>
                </div>
                <div className='col-6'>
                  <div className="d-grid gap-2 d-md-flex justify-content-md-end">
                    <button className="" onClick={this.openCloseNotifications} type="button">All Notifications</button>
                    <button className="" onClick={this.AddNotificationBtn} type="button">Create Notification</button>
                    <button className="" onClick={this.refreshNotifications} type="button">
                      <img className='button-icon' src={refreshIcon}></img>
                    </button>
                  </div>
                </div>
              </div>
            </footer>
          </div>
    );
  }
}

export default NotificationsBoard;